import createApiService, { TServiceReturns } from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";

import validateShipmentResponse from "../models/shipment";
import type { TShipment } from "../shipmentTypes";
import mapShipmentResponse from "../utils/mapShipmentResponse";

const shipmentService = createApiService({});

export const loadShipment = async (shipmentId: string): Promise<TServiceReturns<TShipment, unknown>> => {
  try {
    const response = await shipmentService({ url: API_ROUTES.getShipmentById(shipmentId), method: "GET" });

    if (!response.isSuccess) {
      throw new Error(response.error?.message);
    }

    const shipmentResponse = validateShipmentResponse(response.data);
    const shipment = mapShipmentResponse(shipmentResponse);

    return { isSuccess: true, data: shipment };
  } catch (err) {
    console.error(err);
    return { isSuccess: false };
  }
};
